import LanguageDetector from "i18next-browser-languagedetector";
import { en } from "./en/common";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ptBR } from "./pt-BR/common";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "pt-BR"],
    fallbackLng: "en",

    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "floorbit.language",
    },

    resources: {
      en: {
        translation: en,
      },
      "pt-BR": {
        translation: ptBR,
      },
    },
  });
